import { render, staticRenderFns } from "./averagePowerFactor.vue?vue&type=template&id=5e150451&scoped=true"
import script from "./averagePowerFactor.vue?vue&type=script&lang=js"
export * from "./averagePowerFactor.vue?vue&type=script&lang=js"
import style0 from "./averagePowerFactor.vue?vue&type=style&index=0&id=5e150451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e150451",
  null
  
)

export default component.exports